export const DEFAULT_STALE_TIME = 1000 * 5; // 5 seconds
export const DEFAULT_GC_TIME = 1000 * 60 * 10; // 10 minutes
